var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "lateness-cell" },
    _vm._l(_vm.record.lateness.value, function (latenessValue, index) {
      return _c(
        "div",
        {
          key: `lateness-cell-${index}`,
          staticClass: "lateness-cell-item",
          class: {
            "lateness-cell-item-border-left-grey":
              index === 3 && latenessValue > 0,
            "lateness-cell-item-border-left-white":
              latenessValue > 0 && index !== 0,
          },
          style: {
            "background-color": _vm.getLatenessColor(index, latenessValue),
          },
        },
        [_vm._v(" " + _vm._s(latenessValue === 0 ? "" : latenessValue) + " ")]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }